import axios from 'axios'
import {
  ElNotification as Notification,
  ElMessage as Message,
} from 'element-plus'
import errorCode from '@/utils/errorCode'
import { tansParams } from '@/utils/common'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 对应国际化资源文件后缀
axios.defaults.headers['Content-Language'] = 'zh_CN'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 15000,
})
/* const loadingOptions = {
  text: "loading...",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.3)"
};*/
// let loading = Loading.service(loadingOptions);
// request拦截器
service.interceptors.request.use(
  (config) => {
      // 每次请求都从localStorage获取最新的ticket
      const ticket = localStorage.getItem('ticket');  // 或者从其他地方获取ticket
      if (ticket) {
          config.headers['Ticket'] = ticket;  // 添加到请求头中
      }
      // loading = Loading.service(loadingOptions);
    // 是否需要防止数据重复提交
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error) => {
    console.log(error)
    // loading && loading.close();
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // loading && loading.close();
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      return Promise.reject('无效的会话，或者会话已过期')
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error',
      })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({
        message: msg,
        type: 'warning',
      })
      return Promise.reject('error')
    } else if (code !== 200 && code !== '00000 00000') {
      // 新增 00000 00000 判断条件通过
      Notification.error(msg)
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  (error) => {
    console.log('err' + error)
    // loading && loading.close();
    let { message } = error
    if (message === 'Network Error') {
      message = '后端接口连接异常，请刷新页面重试'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时，请稍后重试'
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常,请稍后重试并联系网站管理员'
    }

    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000,
    // })
    return Promise.reject(error)
  }
)

export default service
